import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';
import { NotificationService, NOTIFICATION_TYPE_ERROR, NOTIFICATION_DURATIONS } from 'ui-components/services/notification-service';

import { SimpleModal } from '../../../../components/simple-modal';
import { updateFulfillmentPlansHoldUntil } from '../../../../fulfillment-plans/fulfillment-plans.api';
import { processEntities } from '../../../../store/entities/entities.bulkload';
import { entitiesBulkload } from '../../../../store/entities/entities.actions';

import messages from './messages';

export const RemoveHoldModal = ({ onClose, fulfillmentPlanId }) => {
  const dispatch = useDispatch();
  const onAction = useCallback(async () => {
    try {
      onClose();
      const response = await updateFulfillmentPlansHoldUntil([fulfillmentPlanId], null);
      const { data: updatedEntityFulfillmentPlans } = response;
      dispatch(entitiesBulkload(processEntities({ fulfillmentPlans: updatedEntityFulfillmentPlans })));
    } catch {
      NotificationService.showNotification({
        notificationType: NOTIFICATION_TYPE_ERROR,
        title: <FormattedMessage {...messages.errorNotificationTitle} />,
        content: <FormattedMessage {...messages.errorNotificationBody} />,
        duration: NOTIFICATION_DURATIONS.SHORT,
      });
    }
  }, [dispatch, fulfillmentPlanId, onClose]);

  return (
    <SimpleModal
      actionMessage={messages.removeHold}
      cancelMessage={messages.cancel}
      headerMessage={messages.removeHold}
      onAction={onAction}
      onCancel={onClose}
      onClose={onClose}
      size='small'
    >
      <Text textType={TextType.Paragraph} value={messages.removeHoldModalContent} />
    </SimpleModal>
  );
};

RemoveHoldModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
};
